import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { validateFieldsArrayForFinalForm } from '@framework/ui/Organisms/FinalForm/validators/validateFieldsArrayForFinalForm';
import { CUSIPS_LIST_ARRAY_NAME } from './constants';
import { validateDuplicate } from '@framework/ui/Organisms/FinalForm/validators/validateDuplicate';
import { validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';

const VALID_CUSIP_LENGTH = 9;

interface IValidateCusipData {
  cusip: string,
  fieldName: string,
}

interface ICusipError {
  cusip: string,
}

export interface ICusipErrors {
  [key: string]: ICusipError,
}

export const validateName = (value: string, fieldName: string) => groupValidators(
    validateMinLength({
      fieldName,
      value,
      length: 3,
    }),
    validateMaxLength({
      fieldName,
      value,
      length: 100,
    }),
)?.[fieldName];

const paramsCusipLists = [
  {
    fieldName: 'name',
    fieldCaption: 'Name',
    functionValidation: [
      {
        name: validateRequiredField,
        params: {},
      },
      {
        name: validateMinLength,
        params: {
          length: 3,
        },
      },
      {
        name: validateMaxLength,
        params: {
          length: 100,
        },
      },
      {
        name: validateDuplicate,
        params: {
          errorText: 'This list name is already exists',
        },
      },
    ],
  },
  {
    fieldName: 'positions',
    fieldCaption: 'cusips',
    functionValidation: [
      {
        name: validateRequiredField,
        params: {},
      },
    ],
  },
];

export const validateCusip = ({ cusip, fieldName }: IValidateCusipData) => {
  const error = { [fieldName]: 'Incorrect format' };

  if (cusip.length !== VALID_CUSIP_LENGTH) {
    return error;
  }

  return null;
};

export const validateCusips = (cusipsData: IValidateCusipData[]) => {
  let errors = {};

  cusipsData.forEach((cusipData) => {
    errors[cusipData.fieldName] = 'Incorrect cusip';
  });

  return errors;
};

export const validate = (values) => validateFieldsArrayForFinalForm(
  CUSIPS_LIST_ARRAY_NAME,
  paramsCusipLists,
  { collection: values[CUSIPS_LIST_ARRAY_NAME] },
);
